module.exports = __webpack_public_path__ + "img/38.4dfe9c7d.jpg";